/* global maksimerGlobalFooterImages */

import { isHover } from './functions';

const calculateStickyDropdownTop = () => {
  const dropdown = document.getElementById('product-dropdown');
  const header = document.getElementById('theme-header');
  const wpadminbar = document.getElementById('wpadminbar');

  let top = 0;

  top += header.offsetHeight;

  if (wpadminbar) {
    top += wpadminbar.offsetHeight;
  }

  dropdown.style.top = `${top}px`;
};

calculateStickyDropdownTop();
setTimeout(calculateStickyDropdownTop, 1000);
window.addEventListener('scroll', calculateStickyDropdownTop);

const productLinks = Array.from(document.getElementsByClassName('top-dropdown-link'));
const dropdownFirstMainLink = document.querySelector('#product-dropdown ul.menu > li');
const dropdownMainLink = Array.from(document.querySelectorAll('#product-dropdown ul.menu > li > a'));

// Toggle active on dropdown element
if (productLinks.length > 0) {
  productLinks.forEach((liElement) => {
    const link = liElement.querySelector('a');

    if (link) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        calculateStickyDropdownTop();
        const target = e.currentTarget.getAttribute('href');
        const dropdownMenu = document.querySelector(target);
        dropdownMenu.classList.toggle('open');
        document.body.classList.toggle('open-top-dropdown');
      });
    }
  });
}

// Assign active to the first item
if (dropdownFirstMainLink) {
  dropdownFirstMainLink.classList.add('active');
}

if (dropdownMainLink) {
  dropdownMainLink.forEach((link) => {
    const name = link.innerHTML;
    const imageURL = maksimerGlobalFooterImages[name];

    if (imageURL) {
      const imageHTML = `<img src="${imageURL}" alt="${name}" class="category-image"/>`;
      link.insertAdjacentHTML('afterend', imageHTML);
    }

    if (link) {
      link.addEventListener('mouseover', (e) => {
        e.preventDefault();
        const parentLi = e.currentTarget.parentNode;
        const parentUl = parentLi.parentNode;

        // Stop if clicking on active item
        if (parentLi.classList.contains('active')) {
          return;
        }

        parentUl.childNodes.forEach((li) => {
          if (li.classList) {
            li.classList.remove('active');
          }
        });

        parentLi.classList.add('active');
      });
    }
  });
}

/**
 * When a user removes it's cursor from the product dropdown it will close after 500ms
 * if the cursor is not moved back to the dropdown
 */
function checkIfDropdownShouldClose() {
  let closeProductDropdown;
  const dropdownMenu = document.getElementById('product-dropdown');

  // When the cursor leaves
  dropdownMenu.addEventListener('mouseleave', () => {
    // Will not close if a user hovers the header
    if (isHover(document.getElementById('theme-header')) === false) {
      closeProductDropdown = setTimeout(() => {
        document.body.classList.remove('open-top-dropdown');
        dropdownMenu.classList.remove('open');
      }, 500);
    }
  });

  // When the cursor enters
  dropdownMenu.addEventListener('mouseenter', () => {
    clearTimeout(closeProductDropdown);
  });
}

checkIfDropdownShouldClose();
